import { MAX_BENEFIT_AGE_LIST } from "../../../../../../legacyComponents/util/api/apis/employer/PermissibleClass/constants"

function escapeCsv(v = "") {
	const s = String(v);
	return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

function formatAmount(value) {
    if (value === null || value === undefined || value === "" || value === 0) return "0.00";
    const num = Number(value);
    if (isNaN(num)) return "0.00";
    /**
     * Form values are ANNUAL CENTS. The CSV is MONTHLY DOLLARS — the same
     * format the upload reads, so download -> edit -> upload round-trips.
     */
    return (num / 1200).toFixed(2);
}

export default function downloadAllowances(plan, values, benefitType) {
	const permissibleClass = plan?.permissibleClasses?.[0]
	const v2 = permissibleClass?.v2
	const columns = getColumns(v2, benefitType)
	const rows = getRows(values, columns)
	
	// Create CSV header from column labels
	const header = columns.map(col => col.label);
	
	// Map rows to CSV data lines
	const lines = rows.map(row => {
		return columns.map(col => {
			const value = row[col.value];
			// Format AGE as number, amounts as currency
			if (col.value === "AGE") {
				return value;
			} else {
				// Annual cents -> monthly dollars.
                return formatAmount(value);			}
		});
	});
	
	// Combine header and lines, escape values, and join with commas and newlines
	const csv = [header, ...lines]
		.map((row) => row.map(escapeCsv).join(","))
		.join("\n");

	const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" })
	const path = window.URL.createObjectURL(blob)
	
	let filename = "Monthly_Allowance"
	if (benefitType === "AGE" && values.v2 && values.selfOnly) filename = "Monthly_Allowance_By_Age"
	if (benefitType === "AGE" && !values.v2) filename = "Monthly_Allowance_By_Age"
	if (benefitType === "FAMILY_AGE") filename = "Monthly_Allowance_By_Family_Age"

	const link = document.createElement("a")
	link.href = path
	link.download = `${filename}.csv`

	document.body.appendChild(link)
	link.click()
	document.body.removeChild(link)

	window.URL.revokeObjectURL(path)
}

function getColumns(v2, benefitType) {
	let columns = [{ label: "Age", value: "AGE", default: "" }]

	if (benefitType === "AGE") {
		columns = [...columns, { label: "Monthly Allocation", key: "selfAmount", value: "SELF_AMOUNT", default: "" }]
	}

	if (benefitType === "FAMILY_AGE" && v2) {
		columns = [
			...columns,
			{ label: "Self", key: "selfAmount", value: "SELF_AMOUNT", default: "" },
			{ label: "First Dependent", key: "spouseAmount", value: "SPOUSE_AMOUNT", default: "" },
			{ label: "Additional Dependent", key: "childAmount", value: "CHILDREN_AMOUNT", default: "" },]
	}
	if (benefitType === "FAMILY_AGE" && !v2) {
		columns = [
			...columns,
			{ label: "Self", key: "selfAmount", value: "SELF_AMOUNT", default: "" },
			{ label: "Self Spouse", key: "spouseAmount", value: "SPOUSE_AMOUNT", default: "" },
			{ label: "Self Children", key: "childAmount", value: "CHILDREN_AMOUNT", default: "" },
			{ label: "Self Spouse Children", key: "allAmount", value: "ALL_AMOUNT", default: "" }
		]
	}

	return columns
}

function getRows(values, columns) {
	const rows = []

	for (let age = MAX_BENEFIT_AGE_LIST.MINIMUM_AGE; age <= MAX_BENEFIT_AGE_LIST.MAXIMUM_AGE; age++) {
		const row = {}

		for (const column of columns) {
			const key = `${column?.key}${age}`
			const name = column?.value

			if (name === "AGE") row[name] = age
			else row[name] = values?.[key] || 0
		}

		rows.push(row)
	}

	return rows
}
